<template>
  <div class="orderGoods">
    <div class="total">共{{ cartInfo.length }}件商品</div>
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-for="(cart,index) in cartInfo"
        :key="cart.id"
      >
        <div class=" "  >
       {{ index+1 }}
        </div>
        <div class="text" @click="showInputModal(cart.id,cart.gys_id,cart.sl)">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ cart.goods_name }}x {{ cart.sl }}{{ cart.type_name }}</div>
		 
            <div class="num">	 供应商:{{ cart.gys_name }}</div>
          </div>
          <div class="attr line1" v-if="cart.title">
            规格：{{ cart.title }}
          </div>
 
        </div>
	 
	
		  <div v-if="edit==true" class="bnt bg-color-red" style="padding: 5px 5px;color:white; "  >修改</div> 
	
 
	  
      </div>
	  	<!-- 弹窗组件 -->
    <div v-if="showModal" class="modal" @click.self="closeModal">
      <div class="modal-content">
        
		
		 修改供应商:
	  <div class="custom-select-container">

 
    <select class="custom-select" v-model="selected">

<option v-for="option in options" v-bind:value="option.value">
    {{ option.text }}
  </option>
     


    </select>
	 
	  </div>
	 
        <div class="actions">
          <button @click="closeModal">取消</button>
          <button @click="confirmInput"  >确定</button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import { editkufanggoods,getgyslist } from "@api/order";
import Modal from '../components/input/input'
import {
  shanchuzhipeigoodsHandle
} from "@libs/order";
// 引用全局VUE中的接口
import Vue from 'vue';
export default {
 components: { Modal },
  name: "OrderGoods",
  props: {
     
    cartInfo: {
      type: Array,
      default: () => []
    },
	edit:{
	default:false
	}
	 

  },
  data: function() {
    return {
	  showModal: false,      // 控制弹窗显示
      tempValue: 0 ,          // 临时存储输入值
	id: '' ,
	options: [],
	 
	selected:''
	
	};
  },
  mounted: function() {
   this.getgys();
  
  },
  methods: {
 getgys() {
	    getgyslist()
        .then(res => {
		   this.options = res.data;
		
		  })
        .catch(err => {
         // this.$dialog.error(err.msg);
        // this.$router.go(-1);
        });
    },
  shanchu(id){
  console.log(id);
    shanchuzhipeigoodsHandle(id)
        .then(() => {
          //location.reload()
		    this.$emit('custom-event');
        })
        .catch(() => {
           
        });
  
  
  
  },
  // 显示输入弹窗
    showInputModal(id,gys_id,sl) {
	if(this.edit==true){
	
 
	
	//console.log(id+'/'+sl);
      this.showModal = true;
      this.tempValue = sl; // 初始化输入值为当前数量
      this.id = id; 
	     this.selected = gys_id; 
      // 自动聚焦输入框
      this.$nextTick(() => {
 
 
      //  this.$refs.modalInput.focus();
		  
        this.$refs.modalInput.select(); // 自动选中文本方便修改
		 
      });
	  	}
    },
    
    // 关闭弹窗
    closeModal() {
      this.showModal = false;
    },
    
    // 确认输入
    confirmInput() {
      
     const gysid = Number(this.seleted);
	  
	  
	  if(gysid==''){
	  alert('请选择供应商');
        return;
	  }
      
      // 更新商品数量
    
	   
			
			
			  editkufanggoods(this.id,this.selected)
        .then((res) => {
           console.log(res);
		    this.$emit('custom-event');
		   
			   
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
			
    
     
      
      this.closeModal();
    },
  
  
  }
};
</script>

<style lang="less"  scoped>
@import "../common/less/index.less";
.cartcontrol{
	font-size: 0;
	.cart-decrease{
		display:inline-block;
		padding:6px;
		transition:all 0.4s linear;
		transform:translate3D(0,0,0);
	    .inner{
	    	display:inline-block;
	    	line-height:24px;
			font-size: 24px;
			color:rgba(0,160,220);
			transform:rotate(0);
			transition:all 0.4s linear;
	    }
		&.move-enter,&.move-leave-to{
			opacity:0;
			transform:translate3D(24px,0,0);
			.inner{
				transform:rotate(180deg);
			}
		}	    
	}
	.cart-count{
		display:inline-block;
		font-size: 10px;
		vertical-align:top;
		width:22px;
		padding-top: 6px;
		color:#93999f;
		line-height:24px;
		text-align: center;
	}
	.cart-add{
		display:inline-block;
		padding:6px;
		line-height:24px;
		font-size: 24px;
		color:rgba(0,160,220)
	}
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* 确保在顶层 */
}

.modal-content {
  background: white;
  padding: 25px; /* 增加内边距 */
  border-radius: 10px; /* 圆角增大 */
  width: 320px; /* 加宽 */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); /* 添加阴影 */
  
  input {
     width: 150px;
    padding: 12px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
    margin-left:20px;
    &:focus {
      border-color: rgba(0, 160, 220);
      outline: none;
    }
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px; /* 增大间距 */
  margin-top: 20px; /* 增加上边距 */
  
  button {
    padding: 10px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
	line-height:20px;
    &:first-child {
      background: #f0f0f0;
      
      &:hover {
        background: #e0e0e0;
      }
    }
    
    &:last-child {
      background: rgba(0, 160, 220);
      color: white;
      
      &:hover {
        background: rgba(0, 140, 200);
      }
    }
  }
}
.custom-select-container {
  position: relative;
  display: inline-block;
  width: 150px;
  margin-top:15px
}
.custom-select {
  display: block;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  font-family: 'Arial', sans-serif;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #f9f9f9;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.custom-select-container::after {
  content: '▼';
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
}
</style>